import { useQuery } from '@tanstack/react-query';
import { fetchProductTypes } from '../services/plans';

export const useProductTypesQuery = () =>
    useQuery({
        queryKey: ['smr', 'product-types'],
        queryFn: fetchProductTypes,
        staleTime: 30 * 60 * 1000,
    });
